import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: number;
  email: string;
  name: string;
  role: 'admin' | 'artist' | 'fan';
  tenantId: number | null;
  tenant?: { id: number; slug: string; artistName: string; artistNumber?: number | null } | null;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  isChecking: boolean;
  setUser: (user: AuthUser | null) => void;
  setToken: (token: string | null) => void;
  setChecking: (value: boolean) => void;
  login: (user: AuthUser, token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isChecking: true,
      setUser: (user) => set({ user }),
      setToken: (token) => set({ token }),
      setChecking: (value) => set({ isChecking: value }),
      login: (user, token) => set({ user, token, isChecking: false }),
      logout: () => set({ user: null, token: null, isChecking: false }),
    }),
    {
      name: 'fans-audio-auth',
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
);
